import { render, staticRenderFns } from "./AccountSettingAffiliate.vue?vue&type=template&id=5622c5da"
import script from "./AccountSettingAffiliate.vue?vue&type=script&lang=js"
export * from "./AccountSettingAffiliate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports